import styles from "~styles.module.css";
import * as React from "react";
import { useState, useRef } from "react";
import copy from "copy-to-clipboard";
import { fullDomain, randString } from "~util";
import { toast } from "react-toastify";

export type DomainDisplayProps = {
  subdomain: string;
  connected: boolean;
  subdomainCallback: (subdomain: string) => void;
};

export function DomainDisplay(props: DomainDisplayProps) {
  const [editing, setEditing] = useState<boolean>(false);
  const editDomainRef = useRef<HTMLInputElement>(null);

  const { subdomain, connected, subdomainCallback } = props;

  return (
    <span>
      Domain:
      <div
        className={editing ? undefined : styles.hoverUnderline}
        style={{
          display: "inline",
          fontSize: 24,
        }}
      >
        <span
          className={styles.textMono}
          style={{ marginLeft: 8, cursor: "pointer" }}
          onClick={() => {
            if (editing) return;
            copy(fullDomain(subdomain));
            toast("Copied!", {
              toastId: "copy",
              autoClose: 1500,
              type: "success",
            });
          }}
        >
          {`${window.location.protocol}//`}
          <div
            style={{
              position: "relative",
              display: editing ? "inline" : "none",
            }}
          >
            <input
              ref={editDomainRef}
              className={styles.textMono}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  subdomain !== (editDomainRef.current?.value ?? "") &&
                    subdomainCallback(editDomainRef.current?.value ?? "");
                  setEditing(false);
                }
              }}
              type="text"
              style={{
                width: 160,
                fontSize: 24,
              }}
            />
            <span
              style={{
                position: "absolute",
                right: 6,
                top: -1,
              }}
              onClick={() => {
                if (editDomainRef.current)
                  editDomainRef.current.value = randString(8);
              }}
            >
              🔀
            </span>
          </div>
          <span
            style={{
              display: editing ? "none" : "inline-block",
              paddingTop: 6,
              paddingBottom: 6,
            }}
          >
            {subdomain}
          </span>
          {`.${import.meta.env.VITE_BACKEND_URL ?? window.location.host}`}
        </span>
      </div>
      {subdomain !== null && (
        <span
          className={styles.editButton}
          style={{
            width: 40,
            borderColor: "#1E1E34",
            cursor: "pointer",
            marginLeft: 8,
          }}
          onClick={() => {
            if (editing && subdomain !== (editDomainRef.current?.value ?? "")) {
              subdomainCallback(editDomainRef.current?.value ?? "");
            } else if (connected) {
              if (editDomainRef.current)
                editDomainRef.current.value = subdomain;
            } else {
              subdomainCallback(subdomain);
              return;
            }
            setEditing(!editing);
          }}
        >
          {editing ? "✅" : connected ? "✏️" : "🔁"}
        </span>
      )}
      <span
        className={styles.box}
        style={{
          backgroundColor: connected ? "#5CB85C" : "#D9534F",
          marginLeft: 8,
          marginRight: 8,
        }}
      >
        {connected ? "Live" : "Stopped"}
      </span>
    </span>
  );
}
